import { FC, useCallback } from 'react';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styles from './index.module.scss';
import { Button } from 'antd';

interface IProps {
  toggleSearchProfilesVisible: (nextValue?: boolean) => void;
}

export const EmptyScreen: FC<IProps> = props => {
  const { toggleSearchProfilesVisible } = props;
  const { t } = useTranslation();
  const onToggleSearchProfilesVisible = useCallback(() => {
    toggleSearchProfilesVisible();
  }, [toggleSearchProfilesVisible]);
  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('KeywordSearch.functionSearchDocumentsTitle')}</div>
      <p className={styles.description}>{t('KeywordSearch.functionSearchDocumentsDescription')}</p>
      <p className={styles.description}>{t('KeywordSearch.functionSearchDocumentsDescription2')}</p>
      <p>{t('KeywordSearch.howItWorks')}</p>
      <ul>
        <li>{t('KeywordSearch.howItWorksPoint1')}</li>
        <li>{t('KeywordSearch.howItWorksPoint2')}</li>
        <li>{t('KeywordSearch.howItWorksPoint3')}</li>
      </ul>
      <p className={styles.description}>{t('KeywordSearch.saveTimeForSearching')}</p>

      <div className={styles.example}>
        <div className={styles.exampleTitle}>{t('KeywordSearch.titleOfParagraph')}</div>
        <div className={styles.exampleText}>
          <Trans i18nKey="KeywordSearch.textOfParagraph" components={{ span: <span /> }} />
        </div>

        <div className={styles.exampleMeta}>
          <div className={styles.exampleDocumentLabel}>{t('KeywordSearch.foundInDocument')}</div>
          <div className={styles.exampleDocument}>{t('KeywordSearch.nameOfDocument')}</div>
        </div>
      </div>
      <Button type={'link'} onClick={onToggleSearchProfilesVisible} className={styles.button}>
        {t('KeywordSearch.setItUp')}
      </Button>
    </div>
  );
};

export default EmptyScreen;
